import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useAuth } from '../../app/stores/auth';
import { useOverlays } from '../../app/stores/overlays';
import { Button } from '../../ui/Button';
import { LocalePicker } from '../settings/LocalePicker';

export function Landing() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user, playAsGuest } = useAuth();
  const openAuth = useOverlays((s) => s.open);
  const [busy, setBusy] = useState(false);

  const play = async (): Promise<void> => {
    setBusy(true);
    try {
      // Кнопка "Играть" не спрашивает ничего: гость создаётся молча, аккаунт
      // предлагается привязать позже (01 §3).
      if (!user) await playAsGuest();
      await navigate('/lobby');
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="flex min-h-dvh flex-col bg-ink">
      <div className="flex items-center justify-between px-4 py-3">
        <span className="font-[family-name:var(--font-display)] text-[15px] font-bold tracking-[0.1em] text-amber">
          JETOPOLIS
        </span>
        <LocalePicker compact />
      </div>

      <div className="flex flex-1 flex-col items-center justify-center gap-6 px-6 text-center">
        <h1 className="max-w-[20ch] font-[family-name:var(--font-display)] text-[26px] leading-tight text-txt sm:text-[36px]">
          {t('common.landing.tagline')}
        </h1>
        <p className="max-w-[52ch] text-[13px] text-mut sm:text-[15px]">
          {t('common.landing.lead')}
        </p>

        <div className="flex w-full max-w-[320px] flex-col gap-2">
          <Button
            variant="primary"
            className="w-full"
            onClick={() => {
              void play();
            }}
            disabledReason={busy ? t('common.state.loading') : undefined}
          >
            {t('common.action.play')}
          </Button>
          <Button
            className="w-full"
            onClick={() => {
              openAuth('auth');
            }}
          >
            {t('common.action.signIn')}
          </Button>
          <span className="text-[11px] text-dim">{t('common.landing.noSignup')}</span>
        </div>

        <ul className="mt-4 flex max-w-[60ch] flex-col gap-2 text-start text-[12px] text-dim">
          {['world', 'time', 'real'].map((k) => (
            <li key={k} className="flex gap-2">
              <span className="text-amber">-</span>
              <span>{t(`common.landing.bullet.${k}`)}</span>
            </li>
          ))}
        </ul>
      </div>
    </main>
  );
}
